import { type DropdownOption } from '~/_shared/baseComponents/dropdown';
import { type TranslationFnc } from '../../../_shared/utils/hooks';
import { BoundaryEditManualMethod } from '../boundaryEditModal/boundaryEditModal.helpers';

export enum BoundaryEditSubmitModalAction {
  AddToExistingTerritory = 'AddToExistingTerritory',
  RemoveBoundariesFromTerritory = 'RemoveBoundariesFromTerritory',
  ReassignTerritory = 'ReassignTerritory',
}

export const getBoundaryEditMethodParam = (t: TranslationFnc, method: BoundaryEditManualMethod) => ({
  method: method === BoundaryEditManualMethod.Selection ? t('selected') : t('drawn'),
});

export const getBoundaryEditSubmitModalActionOptions = (
  t: TranslationFnc, method: BoundaryEditManualMethod, includeAssignToAndRemoveOptions: boolean, includeReassign: boolean
): ReadonlyArray<DropdownOption<BoundaryEditSubmitModalAction>> => {
  const methodParam = getBoundaryEditMethodParam(t, method);

  return ([
    ...includeAssignToAndRemoveOptions ? [{
      name: t('BoundaryEdit.SubmitAction.Add', methodParam),
      value: BoundaryEditSubmitModalAction.AddToExistingTerritory,
    }, {
      name: t('BoundaryEdit.SubmitAction.Remove', methodParam),
      value: BoundaryEditSubmitModalAction.RemoveBoundariesFromTerritory,
    }] : [],
    ...includeReassign ? [{
      name: t('BoundaryEdit.SubmitAction.Reassign', methodParam),
      value: BoundaryEditSubmitModalAction.ReassignTerritory,
    }] : [],
  ]);
};
